export let TeamsPermissionApi = /*#__PURE__*/function (TeamsPermissionApi) {
  TeamsPermissionApi["canCreateTeams"] = "CAN_CREATE_TEAMS";
  TeamsPermissionApi["canViewTeams"] = "CAN_VIEW_TEAMS";
  TeamsPermissionApi["canAdminTeams"] = "CAN_ADMIN_TEAMS";
  return TeamsPermissionApi;
}({});